module.exports = __webpack_public_path__ + "static/media/pc-logo.ae15e9c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/images/pc-logo.svg
// module id = 380
// module chunks = 19